module.exports = __webpack_public_path__ + "pc/img/11_Total-Management.9e2a7c98.png";